import { executeMutation } from 'services/graphQL/clientService.js';
import gql from 'graphql-tag';

const mutation = gql`
  mutation RemoveTeam($input: RemoveTeamInput!) {
    removeTeam(input: $input) {
      success
      errors
    }
  }
`;

export default function removeTeam(input) {
  return executeMutation(mutation, { input });
}
